import { IdValue } from 'its-pages';
import { ROLES } from '../constants/roles';
export interface TokenDoc {
  token: string;
  name: string;
}

export enum TOKEN_TYPE {
  LTICONFIG = 'ltiConfig',
  CREATE_TEACHER = 'CreateTeacher',
  CLASSROOM = 'Classroom',
}

const tokenRoleMap: Record<TOKEN_TYPE, ROLES> = {
  ltiConfig: ROLES.LTICONFIG,
  CreateTeacher: ROLES.TEACHER,
  Classroom: ROLES.STUDENT
}
export const mapTokenToRole = (tokenDocument: TokenDocument) => {
  return tokenRoleMap[tokenDocument.type];
}
export interface TokenDocument {
  token: string;
  type: TOKEN_TYPE;
}

export type TokenDocuments = IdValue<TokenDocument>;
